import { render, staticRenderFns } from "./ReportAnalytic.vue?vue&type=template&id=22472137&"
import script from "./ReportAnalytic.vue?vue&type=script&lang=js&"
export * from "./ReportAnalytic.vue?vue&type=script&lang=js&"
import style0 from "./ReportAnalytic.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports